import { subscription } from "venuescanner-js/schemas/serviceSchema.json";
import planService from "./planService";
/** @class
 * @name Subscription
 * @desc Class definition of a Subscription - schema defined in venuescanner-js/schemas/serviceSchema.json
 */
class Subscription {
  constructor(values = {}) {
    Object.keys(subscription).forEach((key) => {
      this[key] = values[key];
    });
  }

  /** @function
   * @memberof Subscription
   * @name getPlan
   * @desc Fetches the associated Subscription Plan
   * @returns {Promise<Plan>}
   */
  async getPlan() {
    if (!this._plan) this._plan = await planService.byId(this.plan);
    return this._plan;
  }
}

export default Subscription;
